import { STORE_PARAMS, STORE_PARAMS_ERROR, LOADING_PARAMS, } from "../actions/types";
const initialState = {
    brand: null,
    paramsError: null,
    isLoadingParams: false,
};
export default function paramsReducer (state = initialState, action) {
    switch (action.type) {
        case STORE_PARAMS:
            return {
                ...state,
                isLoadingParams: false,
                paramsError: null,
                ...action.payload,
            };
        case LOADING_PARAMS:
            return {
                ...state,
                isLoadingParams: true,
                brand: null,
                paramsError: null,
            };
        case STORE_PARAMS_ERROR:
            return {
                ...state,
                isLoadingParams: false,
                paramsError: action.payload,
                brand: null,
            };
        default:
            return state;
    }
}